import { Button } from "@/components/ui/button"
import { Minus, Pencil, Plus, Trash2 } from "lucide-react"
import { useSortable } from "@dnd-kit/sortable"
import { CSS } from "@dnd-kit/utilities"
import { SortableItemProps } from "@/types/purchase"

export function SortableItem({ item, index, onEdit, onDelete, onQuantityChange }: SortableItemProps) {
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
  } = useSortable({ id: index })

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
  }

  return (
    <li ref={setNodeRef} style={style} className="flex items-center p-3 bg-white rounded-lg border border-gray-200 shadow-sm hover:shadow-md transition-shadow duration-150 ease-in-out">
      {/* Drag Handle */}
      <button {...attributes} {...listeners} className="cursor-move p-1 text-gray-400 hover:text-gray-600 focus:outline-none focus:ring-1 focus:ring-indigo-300 rounded mr-2 shrink-0" aria-label="상품 순서 변경">
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><line x1="8" y1="6" x2="8" y2="18"></line><line x1="16" y1="6" x2="16" y2="18"></line></svg>
      </button>
      
      {/* Item Name and Price */}
      <div className="flex-grow min-w-0 mr-3">
        <p className="text-sm font-medium text-gray-800 truncate" title={item.name}>{item.name}</p>
        <p className="text-xs text-gray-500">{item.price.toLocaleString()}원</p>
      </div>

      {/* Controls */}
      <div className="flex items-center gap-2 shrink-0">
        {/* Quantity Controls */}
        <div className="flex items-center gap-1">
          <Button
            type="button"
            variant="outline"
            size="icon"
            className="h-7 w-7 border-gray-300 text-gray-600 hover:bg-gray-100 rounded-md"
            onClick={() => onQuantityChange(index, Math.max(1, item.quantity - 1))}
            aria-label="수량 감소"
          >
            <Minus className="h-3.5 w-3.5" />
          </Button>
          <span className="w-7 text-center font-medium text-sm text-gray-700 tabular-nums">{item.quantity}</span>
          <Button
            type="button"
            variant="outline"
            size="icon"
            className="h-7 w-7 border-gray-300 text-gray-600 hover:bg-gray-100 rounded-md"
            onClick={() => onQuantityChange(index, item.quantity + 1)}
            aria-label="수량 증가"
          >
            <Plus className="h-3.5 w-3.5" />
          </Button>
        </div>

        {/* Action Buttons */}
        <Button
          size="icon"
          variant="ghost"
          onClick={() => onEdit(index)}
          className="h-7 w-7 text-gray-500 hover:text-indigo-600 hover:bg-indigo-50 rounded-md"
          aria-label="상품 수정"
        >
          <Pencil className="h-4 w-4" />
        </Button>
        <Button
          size="icon"
          variant="ghost"
          onClick={() => onDelete(index)}
          className="h-7 w-7 text-red-500 hover:text-red-700 hover:bg-red-50 rounded-md"
          aria-label="상품 삭제"
        >
          <Trash2 className="h-4 w-4" />
        </Button>
      </div>
    </li>
  )
} 